import { useContext } from 'react'

import { VariantContextType } from './types'

import { BabyPDPVariantContext } from './baby-pdp-variant-context/context'
import { PDPPageVariantContext } from './pdp-page-variant-context/context'

export function useVariantContextValues(type: VariantContextType) {
    const pdpContext = useContext(PDPPageVariantContext)
    const babyPdpContext = useContext(BabyPDPVariantContext)

    const context = type === 'baby-pdp' ? babyPdpContext : pdpContext

    if (!context) {
        throw new Error(
            `useVariantContextValues must be used inside a ${type === 'baby-pdp' ? 'BabyPDPVariantProvider' : 'PDPPageVariantProvider'}`
        )
    }

    return context
}
